import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-form-error',
    templateUrl: './form-error.component.html',
    standalone: false
})
export class FormErrorComponent implements OnInit{

   @Input('message') message: string

  ngOnInit(): void {
  }

}
